import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, useRoutes } from 'react-router-dom';
import { QueryClient, QueryClientProvider, QueryCache } from '@tanstack/react-query';
import { routes } from './routes';
import MetaPixelTracker from './components/MetaPixelTracker';

const Notification = lazy(() => import('./components/Notification'));
const PostModal = lazy(() => import('./components/PostModal/PostModal'));
const ErrorModal = lazy(() => import('./components/ErrorModal'));

const queryClient = new QueryClient({
  queryCache: new QueryCache({}),
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // Don't retry on 4xx client errors (except 401, 408)
        const status = error?.response?.status;
        if (status && status >= 400 && status < 500 && status !== 401 && status !== 408) {
          return false;
        }
        // Don't retry on 500+ server errors
        if (status && status >= 500) {
          return false;
        }
        // Retry once for network errors and other cases
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
  },
});

function AppRoutes() {
  const element = useRoutes(routes);
  return element;
}

function GlobalComponents() {
  return (
    <>
      <PostModal />
      <ErrorModal />
    </>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={null}>
        <Notification />
      </Suspense>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <MetaPixelTracker />
        <AppRoutes />
        <Suspense fallback={null}>
          <GlobalComponents />
        </Suspense>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
